export const PROC_DEF = {
  idepot: {
    label: 'Inregistrare I-Depot (Benelux)', icon: '🏛️',
    sectiuni: [
      { titlu: 'Titularul depozitului', campuri: [
        { e: 'Tip persoana', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'Adresa / Sediu social', t: 'text', r: true },
        { e: 'E-mail de contact', t: 'email', r: true },
        { e: 'Telefon', t: 'tel', r: false },
      ]},
      { titlu: 'Continut depozitat', campuri: [
        { e: 'Titlul / denumirea creatiei', t: 'text', r: true },
        { e: 'Tipul creatiei', t: 'select', o: ['Concept', 'Design', 'Text', 'Software', 'Muzica', 'Altele'], r: true },
        { e: 'Descriere sumara a creatiei', t: 'textarea', r: true },
        { e: 'Fisiere atasate', t: 'upload', r: true, hint: 'PDF, ZIP, JPG, PNG, MP3, MP4' },
      ]},
      { titlu: 'Plata si confirmare', campuri: [
        { e: 'Modalitate plata', t: 'select', o: ['Card', 'Transfer bancar', 'Provizion'], r: true },
        { e: 'Referinta interna dosar', t: 'text', r: false },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  dmi: {
    label: 'Design / Model Industrial', icon: '🎨',
    sectiuni: [
      { titlu: 'Solicitant', campuri: [
        { e: 'Tip solicitant', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Telefon', t: 'tel', r: true },
        { e: 'E-mail', t: 'email', r: true },
      ]},
      { titlu: 'Design / Model industrial', campuri: [
        { e: 'Titlul / descrierea desenului sau modelului', t: 'textarea', r: true, hint: 'Max. 100 de cuvinte' },
        { e: 'Produsul la care se aplica', t: 'text', r: true },
        { e: 'Clasa Locarno', t: 'text', r: true },
        { e: 'Publicare', t: 'select', o: ['Alb-negru', 'Color'], r: true },
        { e: 'Amanarea publicarii (6 luni)?', t: 'checkbox', r: false },
        { e: 'Reprezentari grafice (vederi multiple)', t: 'upload', r: true, hint: 'JPG, PNG, PDF' },
      ]},
      { titlu: 'Oficiu si tip procedura', campuri: [
        { e: 'Oficiu ales', t: 'select', o: ['OSIM', 'EUIPO', 'WIPO'], r: true },
        { e: 'Tip procedura', t: 'select', o: ['Nationala', 'Europeana', 'Internationala'], r: true },
      ]},
      { titlu: 'Plata', campuri: [
        { e: 'Modalitate plata', t: 'select', o: ['Card', 'Transfer bancar / Ordin de plata', 'Provizion'], r: true },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  brevet: {
    label: 'Brevet / Model de Utilitate', icon: '💡',
    sectiuni: [
      { titlu: 'Solicitant', campuri: [
        { e: 'Tip solicitant', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Telefon', t: 'tel', r: true },
        { e: 'E-mail', t: 'email', r: true },
      ]},
      { titlu: 'Inventatori', campuri: [
        { e: 'Nume si prenume inventator(i)', t: 'text', r: true, hint: 'Adaugati cate un inventator pe rand' },
        { e: 'Adresa inventator', t: 'text', r: true },
        { e: 'Declaratie desemnare inventatori', t: 'upload', r: true, hint: 'PDF' },
      ]},
      { titlu: 'Inventia / Modelul de utilitate', campuri: [
        { e: 'Titlul inventiei', t: 'text', r: true },
        { e: 'Tip cerere', t: 'select', o: ['Brevet de inventie', 'Model de utilitate'], r: true },
        { e: 'Problema tehnica rezolvata', t: 'textarea', r: false },
        { e: 'Descrierea inventiei (PDF)', t: 'upload', r: true, hint: 'Conform art.16-17 Regulament' },
        { e: 'Revendicarile', t: 'upload', r: true, hint: 'Conform art.18' },
        { e: 'Rezumatul inventiei (max. 150 cuvinte)', t: 'textarea', r: true },
      ]},
      { titlu: 'Oficiu si tip procedura', campuri: [
        { e: 'Oficiu ales', t: 'select', o: ['OSIM', 'EPO / OEB', 'WIPO – PCT'], r: true },
        { e: 'Tip procedura', t: 'select', o: ['Nationala', 'Europeana', 'Internationala PCT'], r: true },
      ]},
      { titlu: 'Plata', campuri: [
        { e: 'Modalitate plata', t: 'select', o: ['Card', 'Transfer bancar / Ordin de plata', 'Provizion'], r: true },
        { e: 'Referinta interna dosar', t: 'text', r: false },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  marca: {
    label: 'Inregistrare Marca', icon: '™️',
    sectiuni: [
      { titlu: 'Solicitant', campuri: [
        { e: 'Tip solicitant', t: 'select', o: ['PF', 'PJ', 'Asociatie'], r: true },
        { e: 'Nume / Denumire (incl. forma juridica pt. PJ)', t: 'text', r: true },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Cod postal, localitate', t: 'text', r: true },
        { e: 'Telefon', t: 'tel', r: true },
        { e: 'E-mail', t: 'email', r: true },
      ]},
      { titlu: 'Marca', campuri: [
        { e: 'Tip marca', t: 'select', o: ['Verbala', 'Figurativa', 'Combinata', 'Tridimensionala', 'Sonora', 'Dinamica', 'Color', 'Alt tip'], r: true },
        { e: 'Tip cerere marca', t: 'select', o: ['Individuala', 'Colectiva', 'De certificare'], r: true },
        { e: 'Elemente verbale ale marcii', t: 'text', r: false },
        { e: 'Descrierea marcii', t: 'textarea', r: false },
        { e: 'Culori revendicate (cod Pantone / RAL)', t: 'text', r: false },
        { e: 'Reprezentare grafica', t: 'upload', r: true, hint: 'JPG, GIF – max 2MB; MP3/MP4 pt. marci sonore/dinamice' },
        { e: 'Disclaimer (elemente neprotejate)', t: 'textarea', r: false },
      ]},
      { titlu: 'Clasificare Nisa (produse si servicii)', campuri: [
        { e: 'Clasa(e) Nisa', t: 'text', r: true, hint: 'Clase 1–45, separate prin virgula' },
        { e: 'Lista de produse si servicii per clasa', t: 'textarea', r: true },
      ]},
      { titlu: 'Prioritate / Expozitie (daca se revendica)', campuri: [
        { e: 'Data depozitului anterior', t: 'date', r: false },
        { e: 'Nr. cerere anterioara', t: 'text', r: false },
        { e: 'Documente de prioritate', t: 'upload', r: false, hint: 'PDF' },
      ]},
      { titlu: 'Oficiu si tip procedura', campuri: [
        { e: 'Oficiu ales', t: 'select', o: ['OSIM', 'EUIPO', 'WIPO – Madrid'], r: true },
        { e: 'Tip procedura', t: 'select', o: ['Nationala', 'Europeana', 'Internationala'], r: true },
      ]},
      { titlu: 'Plata', campuri: [
        { e: 'Modalitate plata', t: 'select', o: ['Card', 'Transfer bancar / Ordin de plata', 'Provizion'], r: true },
        { e: 'Document de plata / nr. ordin de plata', t: 'text', r: false },
        { e: 'Referinta interna dosar', t: 'text', r: false },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  opozitii: {
    label: 'Opozitii', icon: '⚖️',
    sectiuni: [
      { titlu: 'Opozant', campuri: [
        { e: 'Tip opozant', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Tara', t: 'select', o: ['Romania', 'Germania', 'Franta', 'Italia', 'Spania', 'Altele'], r: true },
        { e: 'Telefon / E-mail', t: 'text', r: true },
      ]},
      { titlu: 'Cererea contestata', campuri: [
        { e: 'Nr. cerere EUTM / OSIM contestata', t: 'text', r: true },
        { e: 'Titularul cererii contestate', t: 'text', r: true },
        { e: 'Data publicarii cererii contestate', t: 'date', r: true },
        { e: 'Intinderea opozitiei', t: 'select', o: ['Toate produsele/serviciile', 'Partial – specificare mai jos'], r: true },
        { e: 'Lista produse/servicii contestate (daca partial)', t: 'textarea', r: false },
      ]},
      { titlu: 'Dreptul anterior invocat', campuri: [
        { e: 'Tip drept anterior', t: 'select', o: ['Marca inregistrata', 'Marca notoriu cunoscuta', 'Denumire comerciala', 'Drept de autor', 'Desen / Model industrial', 'Altele'], r: true },
        { e: 'Nr. inregistrare marca anterioara', t: 'text', r: true },
        { e: 'Data depozitului / inregistrarii', t: 'date', r: false },
        { e: 'Lista produse/servicii ale dreptului anterior', t: 'textarea', r: true },
      ]},
      { titlu: 'Motivele opozitiei', campuri: [
        { e: 'Temei legal', t: 'select', o: ['Risc de confuzie (art.8(1))', 'Marca de renume (art.8(5))', 'Marca agent (art.8(3))', 'Altele'], r: true },
        { e: 'Argumentele opozitiei', t: 'textarea', r: true },
        { e: 'Probe / dovezi', t: 'upload', r: true, hint: 'PDF – declaratii, exemple de utilizare' },
      ]},
      { titlu: 'Plata', campuri: [
        { e: 'Dovada platii taxei de opozitie', t: 'upload', r: true },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  contestatii: {
    label: 'Contestatii', icon: '📜',
    sectiuni: [
      { titlu: 'Contestatar', campuri: [
        { e: 'Tip persoana', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Telefon / E-mail', t: 'text', r: true },
      ]},
      { titlu: 'Decizia contestata', campuri: [
        { e: 'Oficiu care a emis decizia', t: 'select', o: ['EUIPO', 'OSIM', 'Tribunal'], r: true },
        { e: 'Nr. deciziei contestate', t: 'text', r: true },
        { e: 'Data deciziei', t: 'date', r: true },
        { e: 'Nr. dosar / cerere vizata', t: 'text', r: true },
        { e: 'Tip decizie', t: 'select', o: ['Respingere cerere', 'Revocare', 'Declarare nulitate', 'Altele'], r: true },
      ]},
      { titlu: 'Motivele contestatiei', campuri: [
        { e: 'Argumentele contestatiei', t: 'textarea', r: true },
        { e: 'Probe suplimentare', t: 'upload', r: false, hint: 'PDF' },
        { e: 'Cerere de audiere (pt. EUIPO)?', t: 'checkbox', r: false, hint: 'Audierea este discretionara' },
      ]},
      { titlu: 'Plata', campuri: [
        { e: 'Dovada platii taxei de contestatie', t: 'upload', r: true },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
  dosare_instanta: {
    label: 'Dosare Instanta', icon: '🏛️',
    sectiuni: [
      { titlu: 'Reclamant / Petent', campuri: [
        { e: 'Tip persoana', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'CNP / CUI', t: 'text', r: true },
        { e: 'Adresa / Sediu social', t: 'text', r: true },
        { e: 'Avocat / Consilier IP reprezentant', t: 'text', r: true },
        { e: 'Barou / Nr. legitimatie avocat', t: 'text', r: false },
      ]},
      { titlu: 'Parat / Intimat', campuri: [
        { e: 'Tip persoana parat', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire parat', t: 'text', r: true },
        { e: 'Adresa / Sediu parat', t: 'text', r: true },
      ]},
      { titlu: 'Instanta si dosar', campuri: [
        { e: 'Instanta', t: 'select', o: ['Judecatorie', 'Tribunal', 'Curtea de Apel Bucuresti', 'ICCJ'], r: true },
        { e: 'Obiectul cauzei', t: 'select', o: ['Contrafacere', 'Concurenta neloiala', 'Nulitate marca', 'Nulitate brevet', 'Nulitate desen/model', 'Altele'], r: true },
        { e: 'Stadiul dosarului', t: 'select', o: ['Fond', 'Apel', 'Recurs', 'Executare silita'], r: false },
        { e: 'Nr. dosar (daca exista)', t: 'text', r: false },
        { e: 'Data primului termen', t: 'date', r: false },
      ]},
      { titlu: 'Probe si documente', campuri: [
        { e: 'Actiune / cerere de chemare in judecata', t: 'upload', r: true, hint: 'PDF' },
        { e: 'Imputernicire avocatiala', t: 'upload', r: true, hint: 'PDF' },
        { e: 'Probe materiale', t: 'upload', r: false },
        { e: 'Expertiza tehnica (daca exista)', t: 'upload', r: false, hint: 'PDF' },
      ]},
      { titlu: 'Solicitari si termene', campuri: [
        { e: 'Petitele actiunii (ce se solicita)', t: 'textarea', r: true },
        { e: 'Valoarea litigiului (RON)', t: 'text', r: false, hint: 'Pentru calculul taxei de timbru' },
        { e: 'Termen limita intern', t: 'date', r: false },
        { e: 'Observatii / note interne', t: 'textarea', r: false },
      ]},
    ],
  },
  notificari_marketplace: {
    label: 'Notificari Marketplace', icon: '🛒',
    sectiuni: [
      { titlu: 'Titularul dreptului (notificator)', campuri: [
        { e: 'Tip persoana', t: 'select', o: ['PF', 'PJ'], r: true },
        { e: 'Nume / Denumire', t: 'text', r: true },
        { e: 'CNP / CUI', t: 'text', r: false },
        { e: 'Adresa / Sediu', t: 'text', r: true },
        { e: 'Telefon / E-mail de contact', t: 'text', r: true },
      ]},
      { titlu: 'Dreptul de PI incalcat', campuri: [
        { e: 'Tip drept', t: 'select', o: ['Marca', 'Desen / Model industrial', 'Brevet', 'Drept de autor', 'Altele'], r: true },
        { e: 'Nr. inregistrare', t: 'text', r: true },
        { e: 'Oficiu inregistrare', t: 'select', o: ['OSIM', 'EUIPO', 'WIPO', 'Altele'], r: true },
        { e: 'Teritoriu acoperit de drept', t: 'text', r: true },
        { e: 'Certificat de inregistrare', t: 'upload', r: true, hint: 'PDF' },
      ]},
      { titlu: 'Continutul / Produsul reclamat', campuri: [
        { e: 'Platforma marketplace', t: 'select', o: ['Amazon', 'eMAG', 'Alibaba', 'AliExpress', 'Altceva – specificare'], r: true },
        { e: 'URL-ul exact al listingului', t: 'text', r: true, hint: 'Se poate adauga cate un URL per listing' },
        { e: 'ASIN / ID produs', t: 'text', r: false },
        { e: 'Denumire seller reclamat', t: 'text', r: true },
        { e: 'Descrierea incalcarii', t: 'textarea', r: true },
        { e: 'Capturi de ecran ale listingului', t: 'upload', r: true, hint: 'JPG, PNG' },
      ]},
      { titlu: 'Declaratii si cereri', campuri: [
        { e: 'Solicitare', t: 'select', o: ['Retragere listing', 'Suspendare seller', 'Ambele', 'Altele'], r: true },
        { e: 'Declaratie buna-credinta', t: 'checkbox', r: true, hint: 'Continutul notificarii este corect si complet' },
        { e: 'Declaratie exactitate informatii', t: 'checkbox', r: true },
        { e: 'Observatii', t: 'textarea', r: false },
      ]},
    ],
  },
};

export const CAT_IP = [
  { id: 'marca_osim',             name: 'Marca OSIM',          sub: 'Nationala — Romania',         icon: '™️' },
  { id: 'marca_euipo',            name: 'Marca EUIPO',         sub: 'Marca UE (EUTM)',             icon: '🇪🇺' },
  { id: 'marca_wipo',             name: 'Marca WIPO',          sub: 'International — Madrid',      icon: '🌐' },
  { id: 'marca_internationala',   name: 'Marca Internationala', sub: 'GB · US · CA · alt oficiu', icon: '🏳️' },
  { id: 'idepot',                 name: 'I-Depot',             sub: 'Benelux (BOIP)',              icon: '🏛️' },
  { id: 'dmi',         name: 'Design / Model Industrial', sub: 'OSIM · EUIPO · Haga', icon: '🎨' },
  { id: 'brevet',      name: 'Brevet de Inventie', sub: 'OSIM · EPO · PCT',  icon: '💡' },
];

export const CAT_AVIZE = [
  { id: 'opozitie_osim',    name: 'Opozitie OSIM',           sub: 'Marci nationale — Comisia OSIM',               icon: '⚔️' },
  { id: 'opozitie_euipo',   name: 'Opozitie EUIPO',          sub: 'Marci UE — Divizia de opozitie EUIPO',         icon: '🇪🇺' },
  { id: 'contestatie_osim', name: 'Contestatie OSIM',         sub: 'Marci, brevete, desene — Comisie reexaminare', icon: '📝' },
  { id: 'cai_atac_euipo',   name: 'Cai de Atac EUIPO',       sub: 'Camera recurs · Tribunal UE · CJUE',           icon: '⚖️' },
  { id: 'notificare_aviz',  name: 'Aviz Refuz / Notificare', sub: 'OSIM · EUIPO — oficii de examinare',           icon: '📬' },
];

export const CAT_LIT = [
  { id: 'dosar_instanta',        name: 'Dosar Instanta',        sub: 'Tribunal · Curtea de Apel · ICCJ',  icon: '🏛️' },
  { id: 'notificari_marketplace', name: 'Notificari Marketplace', sub: 'Amazon · eMAG · AliExpress',       icon: '🛒' },
];

export const OFFICES_OPTIONS = ['OSIM', 'EUIPO', 'WIPO', 'EPO', 'Benelux (BOIP)', 'USPTO', 'IPO-UK'];
export const TERRITORIES_OPTIONS = ['RO – Romania', 'EU – Uniunea Europeana', 'DE – Germania', 'FR – Franta', 'IT – Italia', 'ES – Spania', 'GB – Regatul Unit', 'US – Statele Unite', 'CN – China', 'JP – Japonia', 'BR – Brazilia', 'IN – India', 'AU – Australia'];
export const NICECLASS_OPTIONS = Array.from({ length: 45 }, (_, i) => `Clasa ${i + 1}`);

// Which territories are automatically linked to each office.
// Selecting an office auto-adds its territories; selecting all of an office's territories auto-adds the office.
export const OFFICE_TERRITORY_MAP = {
  'OSIM':           ['RO – Romania'],
  'EUIPO':          ['EU – Uniunea Europeana'],
  'WIPO':           ['RO – Romania', 'EU – Uniunea Europeana', 'DE – Germania', 'FR – Franta', 'IT – Italia', 'ES – Spania', 'GB – Regatul Unit', 'US – Statele Unite', 'CN – China', 'JP – Japonia', 'BR – Brazilia', 'IN – India', 'AU – Australia'],
  'EPO':            ['EU – Uniunea Europeana', 'GB – Regatul Unit'],
  'Benelux (BOIP)': ['EU – Uniunea Europeana'],
  'USPTO':          ['US – Statele Unite'],
  'IPO-UK':         ['GB – Regatul Unit'],
};
